import logo from './logo.png';

export const settings = {
    "title": "Genius Store",
    "apiUrl": "https://api.expodesign.geniuscloud.it/api",
    "ckdPath": "https://api.expodesign.geniuscloud.it/",
    "tinyKey": "uxd8thxx2a96p0tne20wyfcdx7zvpyprm38j5q5w9qqauy2p",
    "googleMapKey": "AIzaSyDwVSRwXezXuTLG8-VAe1KfNKo7zLPlYJQ",
    "config": {
        "limit": 50,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "supplier": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "sales_agent": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        }
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "logo": logo,
    "data_print": {
        "name": 'Expo Design & Contract Srls',
        "address": 'Viale Europa 44/a 87032 Amantea (CS)',
        "phone": 'Tel: 0982 46386',
        "fax": 'PEC: expocontract@pec.it',
        "email": 'Email: info@expodesigncontract.com',
        "iva": 'P.IVA: 03824820785',
        "cf": '	www.expodesigncontract.com',
        "website": '',
    },
    "dati_pagamento": {
        "iban": "IBAN: IT35O0200880882000107126112",
        "bic": "BIC/SWIFT: UNCRITM1594",
        "banca": "Banca UniCredit",
        "intestatario": "Expo Design & Contract Srls",
    },
    "iva_label": 'inclusa',
    "iva_esclusa": false,
    "sconti": true,
    "usingCache":false,
    "fatturazione": false 
}